import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sn_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const PHONE = "+91 90764 00577";
export const PHONE_RAW = "9076400577";
export const EMAIL = "info@sterlingnest.in";

export const waLink = (msg) =>
  `https://wa.me/919076400577?text=${encodeURIComponent(msg || "Hi, I would like to know more about SterlingNest courses.")}`;

export const slugify = (s) =>
  (s || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export default api;
